import axios from "axios";

const isDev = process.env.NODE_ENV === 'development' //判定是否为开发环境
const http = axios.create({
    baseURL: isDev ? '/api' : process.env.VUE_APP_ROOT,
    headers: {
        "Content-Type": "application/json;charset=utf8",
        "clientId": "web",
        "sign": "",
        "Cross-Origin-Embedder-Policy": "credentialless",
        "Cross-Origin-Opener-Policy": "same-origin"
    }
})

const normalizeToken = (token) => {
    if (!token) return ''
    const raw = String(token).trim()
    // 登录接口可能已返回 "Bearer xxx"，避免拼成 "Bearer Bearer xxx"
    return raw.startsWith('Bearer ') ? raw : `Bearer ${raw}`
}

const clearAuthAndRedirect = () => {
    localStorage.removeItem('token')
    localStorage.removeItem('username')
    if (window.location.pathname !== '/login') {
        window.location.href = '/login'
    }
}

const isAuthFailure = (payload, status) => {
    if (status === 401) return true
    const code = payload?.code
    return code === 9001 || code === 9002 || code === 9003
}

http.interceptors.request.use((config) => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers.Authorization = normalizeToken(token)
    }
    return config
})

http.interceptors.response.use(
    (response) => {
        // 管理端未登录/过期时常返回 HTTP 200 + code=9001
        if (isAuthFailure(response?.data, response?.status)) {
            clearAuthAndRedirect()
        }
        return response
    },
    (error) => {
        const status = error?.response?.status
        const data = error?.response?.data
        if (isAuthFailure(data, status)) {
            clearAuthAndRedirect()
        }
        return Promise.reject(error)
    }
)

export default http
